import { useEffect, useState } from "react";
import { Breadcrumbs, Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { emphasize, styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { PriceListForm } from "./PriceListForm";
import { usePriceListStore } from "../../hooks/usePriceListStore";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { AddProducts } from "./AddProducts";
import CategoryIcon from '@mui/icons-material/Category';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DuplicateListModal } from "./components/DuplicateListModal";
import { DetailListProducts } from "./DetailListProducts";

const StyledBreadcrumb = styled(Chip)(({ theme }) => {
    const backgroundColor =
        theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[800];
    return {
        backgroundColor,
        height: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: theme.typography.fontWeightRegular,
        '&:hover, &:focus': {
            backgroundColor: emphasize(backgroundColor, 0.06),
        },
        '&:active': {
            boxShadow: theme.shadows[1],
            backgroundColor: emphasize(backgroundColor, 0.12),
        },
    };
});

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'text', field: 'validity_date', label: 'Fecha de vigencia', align:'center' },
    { type: 'text', field: 'name_createdby', label: 'Creado por', align:'center' },
    { type: 'text', field: 'quantity_products', label: 'Cantidad de productos', align:'center' },
    // { type: 'text', field: 'total', label: 'Total', align:'center', format:(row) => row.total ? row.total : '0' },
    { type: 'detail', field: 'detail', label: 'Detalles', align:'center' },
];

export const PriceListView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionPriceList, getPriceList, getPriceListByCompany, deletePriceList } = usePriceListStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [listProducts, setListProducts] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [showListProducts, setShowListProducts] = useState<boolean>(false);
    const [duplicate, setDuplicate] = useState<boolean>(false);

    const [addList, setAddList] = useState<boolean>(false);
    const [addProduct, setAddProduct] = useState<boolean>(false);
    const [showDetail, setShowDetail] = useState<boolean>(false);
    const [view, setView] = useState<String>('priceList');
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getPriceListApi()
    },[])

    const getPriceListApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getPriceList(search);
            if(!response){
                setListProducts([]);
                setLoading(false);
                return false;
            }else{
                setListProducts(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setAddList(true);
        setView('addList');
    }
    const onEdit = (rowSelected:any) => {
        setActionPriceList('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionPriceList('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDuplicate = (rowSelected:any) => {
        setActionPriceList('duplicate');
        setRowSelected(rowSelected);
        setDuplicate(true);
    }
    const addProducts = (rowSelected) => {
        setAddProduct(true);
        setRowSelected(rowSelected);
        setView('addProduct');
    }
    const onDetails = (rowSelected) => {
        setShowDetail(true);
        setRowSelected(rowSelected);
        setView('showDetail');
    }
    const showProducts = (rowSelected) => {
        setShowDetail(true);
        setRowSelected(rowSelected);
        setView('showDetail');
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deletePriceList(rowSelected.id)
            if(response){
                getPriceListApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getPriceListApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    const homelist = () => {
        setView('priceList');
        setRowSelected('');
        setAddList(false);
        setAddProduct(false);
        setShowDetail(false);
        getPriceListApi();
    }

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{mt:3}}>
                <StyledBreadcrumb
                    label={"Maestros"}
                />
                <StyledBreadcrumb
                    label={"listas de precios"}
                    onClick={homelist}
                />
                {
                    addList && (
                        <StyledBreadcrumb
                            label={"agregar nueva lista"}
                            onClick={() => {setView('addList')}}
                        />
                    )
                }
                {
                    showDetail && (
                        <StyledBreadcrumb
                            label={"detalle lista"}
                            onClick={() => {
                                setView('showDetail');
                                setAddProduct(false);
                            }}
                        />
                    )
                }
                {
                    addProduct && (
                        <StyledBreadcrumb
                            label={"agregar productos"}
                            onClick={() => {setView('addProduct')}}
                        />
                    )
                }
            </Breadcrumbs>
            
            {
                view == 'priceList' && (
                    <Grid item xs={12}>
                        <CustomTable
                            title={'Listas de precios'}
                            columns={columns}
                            loading={loading}
                            rows={listProducts || []}
                            onRowClick={() => {}}
                            hasOptions
                            onAddFn={onAdd}
                            onAddFnName={'Nueva lista'}
                            onCustomAction={onDuplicate}
                            icon_CustomAction={ <ContentCopyIcon fontSize="small" /> }
                            tooltip_CustomAction={'Duplicar'}
                            onDelete={onDelete}
                            // onDetails={onDetails}
                            // tooltip_detail={"Ver detalle"}
                            onHelper={showProducts}
                            icon_helper={ <CategoryIcon fontSize="small" /> }
                            tooltip_helper={'Ver productos'}
                            // onHelper2={addProducts}
                            // icon_helper2={ <AddCircleIcon fontSize="small" /> }
                            // tooltip_helper2={'Agregar productos'}
                            onSearch={onSearch}
                            dense
                        />
                    </Grid>
                )
            }
            {
                view == 'addList' && (
                    <PriceListForm homelist={homelist}/>
                )
            }
            {
                view == 'showDetail' && (
                    <DetailListProducts setView={setView} setAddProduct={setAddProduct} listSelected = {rowSelected}/>
                )
            }
            {
                view == 'addProduct' && (
                    <AddProducts listSelected = {rowSelected} showProducts={showProducts} setAddProduct={setAddProduct}/>
                )
            }
            {
                duplicate && (
                    <DuplicateListModal
                        open = {duplicate}
                        closeModal = {() => {setDuplicate(false)}}
                        listSelected = {rowSelected}
                        homelist = {homelist}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}